// Breadcrumb.js

import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { BreadcrumbBox } from './BreadcrumbStyled';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LocalStorageKeys, PageName } from '../../QuoteRequest/Content';

const Breadcrumb = ({breadcrumbName}) => {
    const [anchorElNav, setAnchorElNav] = React.useState('');
    const navigate = useNavigate();
    const handleCloseNavMenu = () => {
        setAnchorElNav('');
    };
    const handleMenuItemClick = () => {
        handleCloseNavMenu();
        sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE,PageName.HOMEPAGE)
        navigate('/');
    };
    const breadcrumbs = [
      <div onClick={handleMenuItemClick}> <Link
            key="1"
            color="inherit"
           
            className="breadcrumbLink"
        
        >
            Home
        </Link></div> ,
        <Typography key="3">
            {breadcrumbName}
        </Typography>,
    ];

    return (
        <BreadcrumbBox>
            <Breadcrumbs
                separator={<NavigateNextIcon />}
                aria-label="breadcrumb"
            >
                {breadcrumbs}
            </Breadcrumbs>
        </BreadcrumbBox>
    );
}

export default Breadcrumb;
